import { render, staticRenderFns } from "./brandSelect.vue?vue&type=template&id=0938af3b&scoped=true"
import script from "./brandSelect.vue?vue&type=script&lang=js"
export * from "./brandSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0938af3b",
  null
  
)

export default component.exports